
export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "procedureTitle",
    numeric: false,
    disablePadding: true,
    label: "Procedure Title",
  },
  {
    id: "price",
    numeric: true,
    disablePadding: false,
    label: "Price($)",
  },
  {
    id: "cgst",
    numeric: true,
    disablePadding: false,
    label: "CGST",
  },
  {
    id: "sgst",
    numeric: true,
    disablePadding: false,
    label: "SGST",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];